import {useSelector} from 'react-redux';

import {userSelector, isUnderLimit} from 'entities/user';

import {portMonitorAPI} from '../api/portMonitorAPI';

const useCanCreatePortMonitor = (): boolean => {
    const user = useSelector(userSelector);

    const {data: summary} = portMonitorAPI.useGetSummaryPortMonitorsQuery();

    return isUnderLimit(user?.tariff?.port_monitor_max_count_limit, summary?.total_active);
};

export default useCanCreatePortMonitor;
